module.exports = __webpack_public_path__ + "static/media/termos-uso.acdf774c.svg";